import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';

import { AppUiActions, TestTakerActions } from './../../../store/actions';
import * as fromRoot from './../../../store/reducers';
import { TestNavigationService } from './../../../services/test-navigation.service';

@Component({
    selector: 'navigation-modal',
    template: require('./navigation-modal.component.html'),
    changeDetection: ChangeDetectionStrategy.Default
})
export class NavigationModalComponent implements OnDestroy {

    testlets = [];
    isNavigationModalVisible: boolean;
    private isNavigationModalVisibleSubscription: Subscription;
    private assessmentTestSubscription: Subscription;
    private testNavigationSubscription: Subscription;

    constructor(
        private store: Store<fromRoot.State>,
        private testNavigationService: TestNavigationService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.isNavigationModalVisibleSubscription = store.select(fromRoot.getIsNavigationModalVisible).subscribe(isNavigationModalVisible => {
            this.isNavigationModalVisible = isNavigationModalVisible;
            if (this.testlets.length > 0 && this.isNavigationModalVisible) {
                this.changeDetectorRef.detectChanges();
            }
        });

        this.assessmentTestSubscription = store.select(fromRoot.getAssessmentTest).subscribe(assessmentTest => {
            if (assessmentTest) {
                this.testlets = this.testNavigationService.getTestlets(assessmentTest);
            }
        });

        this.testNavigationSubscription = store.select(fromRoot.getTestNavigation).subscribe(testNavigation => {
            if (testNavigation && this.testlets) {
                this.testlets.forEach((testlet, idx) => {
                    testlet.isSelected = testlet.testNavigation.testPartIndex === testNavigation.testPartIndex && testlet.testNavigation.testletIndex === testNavigation.testletIndex;
                });
            }
        });
    }

    ngOnDestroy() {
        if (this.isNavigationModalVisibleSubscription) {
            this.isNavigationModalVisibleSubscription.unsubscribe();
        }

        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }

        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
    }

    setTestNavigation(testNavigation: PgRendererDto.TestNavigation) {
        this.store.dispatch(new AppUiActions.ToggleNavigationModal(false));
        this.store.dispatch(new TestTakerActions.SetTestNavigation(testNavigation));
    }

    closeNavigationModal() {
        this.store.dispatch(new AppUiActions.ToggleNavigationModal(false));
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/navigation-modal/navigation-modal.component.ts